import React from "react";
import _ from "lodash";
import moment from "moment-timezone";
import ModalWrapper from "./ModalWrapper";
import HighLightRowWrapper from "./HighLightRowWrapper";
import HighchartWrapper from "./HighchartWrapper";
import Highcharts from "highcharts";
import HighchartsXRange from "highcharts/modules/xrange";
import LoadingUI from "./LoadingUI";
import { tdClass, thClass } from "helpers/StyleClass";

import { SegmentAPI } from "apis";
import { parseDuration } from "helpers/DateTransform";

HighchartsXRange(Highcharts);

class SegmentExperimentModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      errMsg: null,
      segmentId: this.props.segmentId,
      segment: this.props.segment,
      experimentData: [],

      options: null,
      experimentIdx: null,
      expMetadata: null,
    };
    console.log(this.props.segment);
    this.handleSelectExperiment = this.handleSelectExperiment.bind(this);
    this.handleChartOption = this.handleChartOption.bind(this);
  }

  async componentDidMount() {
    const { segmentId } = this.state;
    const { startDate } = this.props;
    try {
      if (segmentId) {
        this.setState({ isLoading: true, errMsg: null });

        const result = await SegmentAPI.getSegmentExperiments({
          segmentId,
          startDate: startDate.split(" ")[0],
        });

        const data = _.map(result, (exp, index) => {
          const start = moment.utc(exp.start_date).valueOf();
          const end = result[index + 1]
            ? moment.utc(result[index + 1].start_date).valueOf()
            : moment.utc().valueOf();

          return {
            ...exp,
            start,
            end,
            duration: parseDuration(end - start),
            created: moment(exp.created_at).format("YYYY-MM-DD HH:mm:ss Z"),
            startDate: moment(exp.start_date).format("YYYY-MM-DD HH:mm:ss Z"),
          };
        });

        const selected = data[data.length - 1];

        this.setState(
          {
            experimentData: _.orderBy(data, ["startDate"], ["desc"]),
            experimentIdx: data.length > 0 ? 0 : null,
            expMetadata: selected ? selected.parameters : null,
          },
          () => {
            this.handleChartOption(this);
          }
        );
      }
    } catch (error) {
      this.setState({ errMsg: error.toString() });
    }

    this.setState({ isLoading: false });
  }

  handleSelectExperiment(index) {
    const { experimentData } = this.state;
    const selectedExperiment = experimentData[index];
    this.setState(
      {
        expMetadata: selectedExperiment ? selectedExperiment.parameters : {},
        experimentIdx: index,
      },
      () => {
        this.handleChartOption();
      }
    );
  }

  handleChartOption() {
    const { experimentData, experimentIdx } = this.state;

    if (experimentData.length === 0) return;

    const clickHandler = (id) => {
      this.handleSelectExperiment(id);
    };

    const options = {
      chart: {
        type: "xrange",
        height: 300,
      },
      title: {
        text: "",
      },
      legend: {
        enabled: false,
      },
      yAxis: {
        categories: _.map(experimentData, (exp) => exp.name),
        title: { text: "" },
        reversed: true,
      },
      tooltip: {
        formatter: function () {
          const name = this.yCategory;
          const start = Highcharts.dateFormat("%Y-%m-%d %H:%M:%S", this.x);

          return `
            <b>${name}</b><br/>
            Start: <b>${start}<b><br/>
            ${this.point.name}
          `;
        },
      },
      plotOptions: {
        series: {
          cursor: "pointer",
          point: {
            events: {
              click: function () {
                clickHandler(this.id);
              },
            },
          },
        },
      },
      series: [
        {
          borderColor: "transparent",
          pointWidth: 20,
          data: this._getXrangeData(experimentData, experimentIdx),
          dataLabels: {
            enabled: true,
            format: "{point.name}",
          },
        },
      ],
    };

    this.setState({ options });
  }

  _getXrangeData(data, idx) {
    return _.map(data, (exp, index) => {
      return {
        x: exp.start,
        x2: exp.end,
        y: index,
        id: index,
        name: exp.duration,
        color: index === idx ? "#faf089" : "#7cb5ec",
      };
    });
  }

  render() {
    const { isOpen, onClose } = this.props;

    const {
      isLoading,
      errMsg,
      experimentData,
      expMetadata,
      experimentIdx,
      options,
      segment,
    } = this.state;

    return (
      <ModalWrapper
        isOpen={isOpen}
        handleClose={onClose}
        showCloseFooter={true}
        width="75%"
        title={{
          label: "Latest Experiments for Segment ID: ",
          highlight: `${this.state.segmentId} ${
            segment.intention ? `(intention: ${segment.intention})` : ""
          }`,
        }}
      >
        <div>
          <div className="flex gap-4">
            {/* Left section: table + chart */}
            <div className="w-3/5">
              {/* table */}
              <div
                className="relative mb-4 overflow-y-auto bg-gray-100"
                style={{ height: "300px" }}
              >
                <table className="border table w-full text-sm">
                  <thead className="bg-gray-200 text-gray-800">
                    <tr>
                      <th className={thClass}>Name</th>
                      <th className={thClass}>Mode</th>
                      <th className={thClass}>Created</th>
                      <th className={thClass}>Start Date</th>
                      <th className={thClass}>Duration</th>
                    </tr>
                  </thead>
                  <tbody>
                    {experimentData.map((experiment, idx) => (
                      <HighLightRowWrapper
                        selected={experimentIdx === idx}
                        onClick={() => {
                          this.handleSelectExperiment(idx);
                        }}
                        unselectedClass="hover:bg-gray-200"
                        key={idx}
                      >
                        <td className={tdClass}>{experiment.name}</td>
                        <td className={tdClass}>{experiment.mode}</td>
                        <td className={tdClass}>{experiment.created}</td>
                        <td className={tdClass}>{experiment.startDate}</td>
                        <td className={tdClass}>{experiment.duration}</td>
                      </HighLightRowWrapper>
                    ))}
                    {experimentData.length === 0 && !isLoading && !errMsg && (
                      <tr>
                        <td
                          colSpan="6"
                          className="border p-2 text-center text-gray-500"
                        >
                          No experiments found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {isLoading && (
                  <div className="flex w-full items-center justify-center">
                    <LoadingUI iconOnly={true}></LoadingUI>
                  </div>
                )}
                {errMsg && (
                  <div className="flex w-full items-center justify-center pt-4 text-red-600">
                    {errMsg}
                  </div>
                )}
              </div>
              {/* chart */}
              <div>
                {options && (
                  <HighchartWrapper options={options}></HighchartWrapper>
                )}
              </div>
            </div>
            {/* Right section: JSON viewer */}
            <div
              className="mb-4 w-2/5 overflow-y-auto bg-blue-100 p-2 text-sm"
              style={{ height: "600px" }}
            >
              {expMetadata && <pre>{JSON.stringify(expMetadata, null, 2)}</pre>}
            </div>
          </div>
        </div>
      </ModalWrapper>
    );
  }
}

export default SegmentExperimentModal;
